import { createContext, Dispatch, SetStateAction } from 'react'
import { GridRowSelectionModel } from '@mui/x-data-grid-pro'

import { DeviceTableRow, GroupByKey } from './components/devices-tab-panel/types'

export const defaultContext = {
  folder: undefined as IFolderType | undefined,
  folderAttributes: undefined as IFolderAttributesType | undefined,
  setFolderAttributes: (() => {}) as Dispatch<SetStateAction<IFolderAttributesType | undefined>>,
  folderAttributesLoading: false as boolean,
  folderTree: undefined as IFolderTree | undefined,
  folderRoots: [] as number[],
  isParticipantView: false as boolean,
  isAccountView: false as boolean,
  isLoading: true as boolean,
  isLoadingAlerts: true as boolean,
  searchText: '',
  setSearchText: (() => {}) as Dispatch<SetStateAction<string>>,
  peopleTabRefreshCounter: 0,
  setPeopleTabRefreshCounter: (() => {}) as Dispatch<SetStateAction<number>>,
  tabIndex: '',
  deviceView: 'default' as 'default' | 'compact' | 'micro',
  setDeviceView: (() => {}) as Dispatch<SetStateAction<'default' | 'compact' | 'micro'>>,
  deviceAction: undefined as 'pause' | 'unpause' | 'rma' | 'move' | 'deactivate' | undefined,
  setDeviceAction: (() => {}) as Dispatch<SetStateAction<'pause' | 'unpause' | 'rma' | 'move' | 'deactivate' | undefined>>,
  deviceGroupBy: 'alertSeverity' as GroupByKey,
  setDeviceGroupBy: (() => {}) as (newValue: GroupByKey) => void,
  deviceDisplayFirmware: [] as string[],
  setDeviceDisplayFirmware: (() => {}) as Dispatch<SetStateAction<string[]>>,
  deviceHideDeactivated: false as boolean,
  setDeviceHideDeactivated: (() => {}) as Dispatch<SetStateAction<boolean>>,
  pausedDeviceCount: 0,
  setPausedDeviceCount: (() => {}) as Dispatch<SetStateAction<number>>,
  firmwareVersions: [] as string[],
  setFirmwareVersions: (() => {}) as Dispatch<SetStateAction<string[]>>,
  pauseModalStatus: { open: false, devices: [] } as { open: boolean; devices: DeviceTableRow[] },
  setPauseModalStatus: (() => {}) as Dispatch<SetStateAction<{ open: boolean; devices: DeviceTableRow[] }>>,
  unpauseModalStatus: { open: false, devices: [] } as { open: boolean; devices: DeviceTableRow[] },
  setUnpauseModalStatus: (() => {}) as Dispatch<SetStateAction<{ open: boolean; devices: DeviceTableRow[] }>>,
  returnModalStatus: { open: false, devices: [] } as { open: boolean; devices: DeviceTableRow[] },
  setReturnModalStatus: (() => {}) as Dispatch<SetStateAction<{ open: boolean; devices: DeviceTableRow[] }>>,
  moveDeviceModalStatus: { open: false, devices: [] } as { open: boolean; devices: DeviceTableRow[] },
  setMoveDeviceModalStatus: (() => {}) as Dispatch<SetStateAction<{ open: boolean; devices: DeviceTableRow[] }>>,
  deactivateModalStatus: { open: false, devices: [] } as { open: boolean; devices: DeviceTableRow[] },
  setDeactivateModalStatus: (() => {}) as Dispatch<SetStateAction<{ open: boolean; devices: DeviceTableRow[] }>>,
  activateModalStatus: { open: false } as { open: boolean; device: DeviceTableRow | undefined },
  setActivateModalStatus: (() => {}) as Dispatch<SetStateAction<{ open: boolean; device: DeviceTableRow | undefined }>>,
  setFolderRefreshCounter: (() => {}) as Dispatch<SetStateAction<number>>,
  alerts: [] as IFolderAlertExtended[],
  selectedDeviceIds: {
    type: 'include',
    ids: new Set(),
  } as GridRowSelectionModel,
  setSelectedDeviceIds: (() => {}) as Dispatch<SetStateAction<GridRowSelectionModel>>,
  isScrolled: false as boolean,
  denseViewForTableMultiselect: false,
  setDenseViewForTableMultiselect: (() => {}) as Dispatch<SetStateAction<boolean>>,
  devicePhotoRefreshCounter: 0,
  setDevicePhotoRefreshCounter: (() => {}) as Dispatch<SetStateAction<number>>,
}

const AccountsContext = createContext(defaultContext)

export default AccountsContext
